module.exports = __webpack_public_path__ + "static/media/helpingHand.15fe4949.webp";